<template>
  <div class="our-content-area ptb-100 bg-gondola3 position-relative z-1">
    <div class="container mw-1356">
      <div class="row align-items-center">
        <div class="col-lg-6 col-xl-7">
          <div
            class="our-content-img position-relative z-2 text-center text-lg-end"
          >
            <img
              src="@/assets/images/our-content.png"
              alt="our-content"
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-delay="100"
            />
            <img
              src="@/assets/images/shape-5.png"
              class="shape shape-5 z-1"
              alt="shape"
            />
          </div>
        </div>
        <div
          class="col-lg-6 col-xl-5"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="200"
        >
          <div class="our-content position-relative z-1">
            <span class="top-title">محتوانا</span>
            <h2 class="text-white">المزيد لتشاهده دائمًا</h2>
            <p class="text-silver">
              مع مكتبة Loay IPTV الواسعة والمتنوعة من القنوات والمحتوى، لن تفوتك
              مبارياتك الرياضية المفضلة أو برامجك ومسلسلاتك المفضلة.
            </p>
            <p>
              <span class="text-white">
                استمتع بقنوات رياضية حصرية ومحتوى ترفيهي متجدد وتجربة مشاهدة
                مرنة تناسب جميع أفراد العائلة.
              </span>
            </p>
            <ul class="ps-0 list-unstyled content-list">
              <li class="d-flex align-items-center">
                <i class="ti ti-circle-check"></i>
                <span>أكثر من 25,000 قناة عالمية بجودة 4K</span>
              </li>
              <li class="d-flex align-items-center">
                <i class="ti ti-circle-check"></i>
                <span>أكثر من 500 ألف فيلم جديد وكلاسيكي</span>
              </li>
            </ul>
            <RouterLink to="/about-us" class="btn">
              <span class="border-style">عرض قائمة المحتوى</span>
            </RouterLink>

            <img
              src="@/assets/images/shape-7.png"
              class="shape shape-7"
              alt="shape"
            />
          </div>
        </div>
      </div>
    </div>
    <img src="@/assets/images/shape-6.png" class="shape shape-6" alt="shape" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "OurContent",
});
</script>